import { render, staticRenderFns } from "./assessment-card.vue?vue&type=template&id=4ad08d53"
import script from "./assessment-card.ts?vue&type=script&lang=ts&external"
export * from "./assessment-card.ts?vue&type=script&lang=ts&external"
import style0 from "./assessment-card.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports